import { createSlice, createSelector } from '@reduxjs/toolkit';

const initialState = {
    app: {},
    page: {},
    currentPage: "home"
};
const variableSlice = createSlice({
    name: 'variables',
    initialState,
    reducers: {
        setVariable: (state, action) => {
            const { scope, name, value } = action.payload;
            const variable = scope === "app" ? state.app[name] : state.page[action.payload.pageId][name];
            const valueIsObject = typeof value === "object" && value !== null;
            const existingValueIsObject = typeof variable.value === "object" && variable.value !== null;
            if (valueIsObject && existingValueIsObject) {
                Object.entries(value).forEach(([k, v]) => {
                    // @ts-ignore we know its an object so its indexible
                    variable.value[k] = v;
                });
            }
            else {
                variable.value = value;
            }
        },
        setAppVariables: (state, action) => {
            const { variables } = action.payload;
            variables.forEach(({ name, value }) => {
                state.app[name].value = value;
            });
        },
        setPageVariables: (state, action) => {
            const currentPage = state.currentPage;
            const { variables } = action.payload;
            variables.forEach(({ name, value }) => {
                state.page[currentPage][name].value = value;
            });
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setVariableProp: (state, action) => {
            const { scope, name, value } = action.payload;
            const recursiveSet = (obj, dotNotation, value) => {
                if (typeof dotNotation == 'string') {
                    return recursiveSet(obj, dotNotation.split('.'), value);
                }
                else if (dotNotation.length == 1 && value !== undefined && typeof obj !== "undefined")
                    return obj[dotNotation[0]] = value;
                else if (dotNotation.length == 0)
                    return obj;
                else if (obj[dotNotation[0]] !== undefined)
                    return recursiveSet(obj[dotNotation[0]], dotNotation.slice(1), value);
            };
            recursiveSet(state, name, value);
            return state;
        },
        // Use this for only set component props action
        setVariableProps: (state, action) => {
            const { variables } = action.payload;
            variables.forEach(variable => {
                const { scope, name, value } = variable;
                const recursiveSet = (obj, dotNotation, value) => {
                    if (typeof dotNotation == 'string') {
                        return recursiveSet(obj, dotNotation.split('.'), value);
                    }
                    else if (dotNotation.length == 1 && value !== undefined && typeof obj !== "undefined")
                        return obj[dotNotation[0]] = value;
                    else if (dotNotation.length == 0)
                        return obj;
                    else if (obj[dotNotation[0]] !== undefined)
                        return recursiveSet(obj[dotNotation[0]], dotNotation.slice(1), value);
                };
                let varName = name;
                if (scope === "page")
                    varName = `page.${state.currentPage}.${name.split(".")[0]}.value.${name.split(".")[1]}`;
                recursiveSet(state, varName, value);
            });
            return state;
        },
        setVariables: (state, action) => {
            state.app = action.payload.app;
            state.page = action.payload.page;
        }
    },
});
const { setVariable, setVariables, setVariableProp, setVariableProps, setCurrentPage } = variableSlice.actions;
const selectAppVariables = (state) => state.variables.app;
const selectPageVariables = (state) => state.variables.page;
const selectCurrentPage = (state) => state.variables.currentPage;
const selectVariablesWithDescriptors = createSelector(selectAppVariables, selectPageVariables, (state, args) => args, (appVariables, pageVariables, { descriptors, pageId }) => {
    const appVars = {};
    const pageVars = {};
    descriptors.forEach(({ scope, name }) => {
        var _a, _b;
        if (scope === "app") {
            appVars[name] = (_a = appVariables[name]) === null || _a === void 0 ? void 0 : _a.value;
        }
        else {
            pageVars[name] = pageId.length > 0 ? (_b = pageVariables[pageId][name]) === null || _b === void 0 ? void 0 : _b.value : {};
        }
    });
    return {
        app: appVars,
        page: pageVars
    };
});
const selectAppAndCurrentPageVariables = createSelector(selectAppVariables, selectPageVariables, selectCurrentPage, (appVariables, pageVariables, currentPage) => {
    return {
        app: Object.fromEntries(Object.entries(appVariables).map(([name, variable]) => {
            return [name, variable.value];
        })),
        page: currentPage.length > 0 ? Object.fromEntries(Object.entries(pageVariables[currentPage]).map(([name, variable]) => {
            return [name, variable.value];
        })) : {}
    };
});
const createVariablesByNameAndCategorySelector = (pageId, descriptors) => {
    return (state) => {
        const vars = {
            app: {},
            page: {}
        };
        descriptors.forEach(({ scope, name }) => {
            var _a, _b;
            if (scope === "app") {
                const value = (_a = state.variables.app[name]) === null || _a === void 0 ? void 0 : _a.value;
                if (typeof value !== "undefined") {
                    vars.app[name] = value;
                }
            }
            else if (scope === "page") {
                const value = (_b = state.variables.page[pageId][name]) === null || _b === void 0 ? void 0 : _b.value;
                if (typeof value !== "undefined") {
                    vars.page[name] = value;
                }
            }
        });
        return vars;
    };
};
var variableReducer = variableSlice.reducer;

export { createVariablesByNameAndCategorySelector, variableReducer as default, selectAppAndCurrentPageVariables, selectAppVariables, selectCurrentPage, selectPageVariables, selectVariablesWithDescriptors, setCurrentPage, setVariable, setVariableProp, setVariableProps, setVariables, variableSlice };
//# sourceMappingURL=variablesSlice.js.map
